import * as React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import ChatClient from 'fk-cp-chat';
import getImageUrl from 'utils/getImageUrl';
import Button from 'components/Button';
import { stringTemplate } from 'components/StringWidget/StringWidget';
import { TOAST_LEVELS } from 'components/Toast/Toast';
import styles from './ChatFeedback.css';
const inactiveOutlineColor = '#dbdbdb';
export default class ChatFeedback extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = () => {
            let feedbackResponse;
            try {
                feedbackResponse = JSON.parse(this.props.responseBody);
                const sendFeedbackResponse = {
                    type: 'feedbackResponse',
                    response: {
                        id: this.state.activeIconId,
                        comment: this.state.inputComment
                    },
                    metadata: feedbackResponse.metadata
                };
                this.chatClient.sendFeedbackAction(this.props.selectedChat, sendFeedbackResponse);
                this.context.toast &&
                    this.context.toast.show({
                        message: stringTemplate('feedbackThankYouText'),
                        ttl: 3000,
                        level: TOAST_LEVELS.SUCCESS
                    });
                this.props.closeModal();
            }
            catch (_e) {
                // no-op
            }
        };
        this.onIconClick = (icon) => () => {
            this.setState({ activeIconId: icon.id });
        };
        this.updateComment = (e) => {
            if (e.target instanceof HTMLInputElement) {
                this.setState({ inputComment: e.target.value });
            }
        };
        this.state = {
            activeIconId: '',
            inputComment: ''
        };
        this.chatClient = ChatClient.getInstance();
    }
    render() {
        let feedbackResponse;
        try {
            feedbackResponse = JSON.parse(this.props.responseBody);
        }
        catch (_e) {
            // no-op
        }
        const { title = '', subtitle = '', placeholderText = '', buttonText = '' } = feedbackResponse && feedbackResponse.data;
        const icons = feedbackResponse && feedbackResponse.responses;
        const { activeIconId, inputComment } = this.state;
        return (<div className={styles['chat-feedback-container']}>
				{feedbackResponse && feedbackResponse.data && icons && (<div className={styles['chat-feedback-body']}>
						<div className={styles['heading-text']}>{title}</div>
						<div className={styles['sub-heading-text']}>{subtitle}</div>
						<div className={styles['icons-container']}>
							{icons.map(icon => (<div className={styles['icon-container']} key={icon.id} onClick={this.onIconClick(icon)}>
									<div className={cx(styles['icon'], {
            [styles['inactive-icon']]: icon.id !== activeIconId && activeIconId !== ''
        })} style={{ borderColor: icon.id === activeIconId ? icon.data.activeColor : inactiveOutlineColor }}>
										<img src={getImageUrl(icon.data.imageUrl, '100', '90')} className={cx(styles['icon-image'], {
            [styles['icon-image-opacity30']]: icon.id !== activeIconId && activeIconId !== ''
        })} alt={icon.data.optionText}/>
									</div>
									<div className={cx(styles['icon-text'], {
            [styles['inactive-icon-text']]: icon.id !== activeIconId && activeIconId !== ''
        }, { [styles['active-icon-text']]: icon.id === activeIconId })}>
										{icon.data.optionText}
									</div>
								</div>))}
						</div>
						<div className={styles['input-form-container']}>
							<form className={styles['input-form']}>
								<input className={styles['input-text']} type="text" value={inputComment} placeholder={placeholderText} onChange={this.updateComment}/>
							</form>
						</div>
					</div>)}
				<Button secondary className={styles['orange-btn']} onClick={this.handleClick} disabled={activeIconId === ''}>
					{buttonText}
				</Button>
			</div>);
    }
}
ChatFeedback.contextTypes = {
    toast: PropTypes.object
};
